var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AsiCard',{attrs:{"icon":_vm.icon,"icon-bg-color":_vm.iconBgColor,"title":_vm.$t('constants.roleCustomer'),"unwrapped":""}},[_c('AsiContentContainer',[_vm._v(" "+_vm._s(_vm.$t('uiTerms.roleDescCustomer'))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }